export const VERIFIED_MEMBERSHIP_STATUS = "Verified";
const LEGACY_VETTED_MEMBERSHIP_STATUS = "Vetted";

export const isVerifiedMembershipStatus = (status?: string | null): boolean =>
  status === LEGACY_VETTED_MEMBERSHIP_STATUS || status === VERIFIED_MEMBERSHIP_STATUS;

export const formatMembershipStatusDisplay = (status?: string | null): string => {
  if (!status) {
    return "";
  }

  if (status === LEGACY_VETTED_MEMBERSHIP_STATUS) {
    return VERIFIED_MEMBERSHIP_STATUS;
  }

  return status;
};

const groupMembershipVerification = (
  memberships: { bubbleId?: string | null; bubbleName?: string | null; status?: string | null }[],
): boolean[] => {
  const verificationByMembership = new Map<string, boolean>();

  for (const membership of memberships) {
    const key = membership.bubbleId ?? membership.bubbleName?.trim();
    if (!key) {
      continue;
    }

    const isVerified = isVerifiedMembershipStatus(membership.status);
    verificationByMembership.set(key, (verificationByMembership.get(key) ?? false) || isVerified);
  }

  return [...verificationByMembership.values()];
};

export const getDistrictUserDisplayStatus = (
  membershipStatuses:
    | { bubbleId?: string | null; bubbleName?: string | null; status?: string | null }[]
    | null
    | undefined,
  userStatus?: string | null,
): string => {
  const membershipVerification = groupMembershipVerification(membershipStatuses ?? []);

  if (membershipVerification.length > 0 && membershipVerification.every(Boolean)) {
    return VERIFIED_MEMBERSHIP_STATUS;
  }

  return formatMembershipStatusDisplay(userStatus);
};
